<template>
  <NewMega
    :menu="menuContent"
    menu-alignment="center"
    element="header"
    handler="click"
  >
    <!-- meg menu internal layout per item -->
    <template #default="{ item, onClose }">
      <InnerContent
        :content="item"
        @close-dropdown="onClose"
      />
    </template>

    <template #mobile-icon="data">
      <icon-base icon-name="chevron-right" class="icon-mobile">
        <icon-chevron-right />
      </icon-base>
    </template>
    <template #dropdown-icon="data">
      <icon-base icon-name="chevron-down" class="icon-dropdown">
        <icon-chevron-down />
      </icon-base>
    </template>
  </NewMega>
</template>

<script>
import NewMega from './new-mega.vue'
import InnerContent from './internal-layout.vue'
import IconBase from './icons/iconBase.vue'
import IconChevronRight from './icons/icons/iconChevronRight.vue'
import IconChevronDown from './icons/icons/iconChevronDown.vue'

export default {
  components: {
    NewMega,
    InnerContent,
    IconBase,
    IconChevronRight,
    IconChevronDown
  },
  props: {
    menuContent: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss">
@import '~@scss/custom.scss';
.vsm-menu  {
    --mega-backdrop-background-color:rgba(0,0,0, .3);
    --mega-backdrop-z-index:300;
    @include media-breakpoint-up(md) {
    --mega-backdrop-z-index:150;
    }
    --mega-primary-z-index:250;
    --mega-container-padding:1em;

    //inner content
    --mega-menu-inner-max-width:1140px; //emulate vc bootstrap container width

    //primary nav
    --mega-primary-background:black;
    --primary-nav-max-width:1140px;
    --mobile-dropdown-max-width:400px;

    //primary item
    --mega-primary-item-font-size:1em;
    --mega-primary-font-weight:300;
    --mega-primary-font-family: sans-serif;

    --mega-primary-item-icon-size:1em;

    --mega-primary-item-icon-color:#fff;
    --mega-primary-item-icon-hover-color:#c0c0c0;
    --mega-primary-item-icon-active-color:#000;

    --mega-primary-item-text-color:#fff;
    --mega-primary-item-text-hover-color:#c0c0c0;
    --mega-primary-item-text-active-color:#000;


    --mega-primary-item-background-color: transparent;
    --mega-primary-item-background-hover-color: rgba(255, 255, 255, 0.15);
    --mega-primary-item-background-active-color: #fff;

    //mobile open header
    --menu-header-background-color:#efefef;
    --menu-header-padding:1em;
    --menu-header-icon-size: 1.25em;
    --menu-header-icon-color:black;
    --menu-header-title-font-size:1.25em;
    --menu-header-title-color:black;
}

//primary region
.primary-nav-inner {
    display: flex;
    max-width: var(--primary-nav-max-width);
    margin: 0 auto;
    .vsm-list {
        padding: 0;
        list-style: none;
        margin: 0;
        width:100%;

        &.menu-align-left {
            justify-content: flex-start;
        }
        &.menu-align-center, &.menu-align-centered {
            justify-content: center;
        }
        &.menu-align-right {
            justify-content: flex-end;
        }
    }
}
.primary-nav-region {
    background: var(--mega-primary-background);
    position: relative;
    z-index:var(--mega-primary-z-index);
}

//backdrop overlay
.vsm-background {
    z-index: var(--mega-backdrop-z-index);
    background: var(--mega-backdrop-background-color);
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    opacity:0;
    transition: .3s ease-in-out;
    pointer-events: none;

}
.vsm-overlay-active {
    .vsm-background {
        opacity:1;
        pointer-events: all;
        cursor: pointer;
    }
}

.vsm-menu {
    width: 100%;
}

.vsm-section_menu {
    width:100%;
    @include media-breakpoint-up(md) {
        width: auto;
    }

    .vsm-link {
        transition-property: background-color, color;
        transition-duration: .3s;
        transition-timing-function: ease-in-out;
        background: var(--mega-primary-item-background-color);
        color: var(--mega-primary-item-text-color);
        font-size: var(--mega-primary-item-font-size);
        font-weight:var(--mega-primary-font-weight);
        font-family:var(--mega-primary-font-family);
        display: flex;
        width: 100%;
        border:0px;
        padding:.75em 1em;
        .icon {
            width:var(--mega-primary-item-icon-size);
            height:var(--mega-primary-item-icon-size);
            stroke: var(--mega-primary-item-icon-color);
            transition-property: stroke, color, transform;
            transition-duration: .3s;
            transition-timing-function: ease-in-out;

            &.icon-dropdown {
                @include media-breakpoint-down(md) {
                    display: none;
                }
            }
            &.icon-mobile {
                @include media-breakpoint-up(md) {
                    display: none;
                }

            }
        }
        &:hover, &:focus {
            background: var(--mega-primary-item-background-hover-color);
            color: var(--mega-primary-item-text-hover-color);
            .icon {
                stroke: var(--mega-primary-item-icon-hover-color);
            }
        }

        &.vsm-active {
            background: var(--mega-primary-item-background-active-color);
            color: var(--mega-primary-item-text-active-color);

            .icon-dropdown {
                transform: rotate(180deg);
            }

            .icon {
                stroke: var(--mega-primary-item-icon-active-color);
            }
        }
    }
}

.vsm-link.vsm-has-dropdown {
    align-items: center;
    justify-content: space-between;
    gap: 0.5em;
}

.vsm-dropdown-header {
    display: none;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: var(--menu-header-padding);
    background: var(--menu-header-background-color);
    //header shown on mobile only
    @include media-breakpoint-down(md) {
        display: flex;
    }
    .title {
        margin: 0;
        color:var(--menu-header-title-color);
        font-size: var(--menu-header-title-font-size);
    }

    .icon {
        width: var(--menu-header-icon-size);
        height: var(--menu-header-icon-size);
        stroke: var(--menu-header-icon-color);
        display: flex;
    }
}

.vsm-menu .vsm-dropdown {
    position: absolute;
    z-index: 1000;
    left: 0;
    right: 0;
    pointer-events: none;
    opacity: 0;
    will-change: transform, opacity;
    transition-property: transform, opacity;
    transition-duration: .25s;
    @include media-breakpoint-down(md) {
    max-width: var(--mobile-dropdown-max-width);
    }
}



.vsm-dropdown-section {
    @include media-breakpoint-down(md) {
    opacity: 1;
    }
    pointer-events: none;
    will-change: transform, opacity;
    transition-property: transform, opacity;
    transition-duration: .3s;
}

.vsm-menu.vsm-dropdown-active .vsm-dropdown {
    opacity: 1;
    pointer-events: auto;
    transform: none;

    @include media-breakpoint-down(md) {
        position: fixed;
    }
}

.vsm-menu.vsm-dropdown-active .vsm-dropdown-section.vsm-active {
    pointer-events: auto;
}

.vsm-menu.vsm-dropdown-active .vsm-dropdown-section {
    transform: translateX(0);

}

.vsm-dropdown-section{
    opacity:0;
    transform: translateX(-100%);
    transition: all .3s ease-in-out;

    @include media-breakpoint-up(md) {
        transform: translateY(-.5em);
    }
    &.vsm-active {
    opacity: 1;
        @include media-breakpoint-down(md) {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 2100;
        overflow: hidden;
        }
    }
}

// Styles, to quickly start using the component
// You can delete, change or add your own

.vsm-dropdown {
    @include media-breakpoint-down(md) {
        top: 0;
        height: 100%;
        width: 100%;
    }
}

// Let's simplify the work with menu items (logo, menu, buttons, etc)
.vsm-root {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    @include media-breakpoint-up(md) {
        flex-direction: row;
        .vsm-link {
            width: auto;
        }

    }
}

// All menu items (element props: a, button, span, etc) are
// made the same in style

.vsm-dropdown-content {
    width: 100%;
    min-height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    @include media-breakpoint-down(md) {
        position:relative;
        height:100%;
        display: flex;
        flex-direction: column;
    }
}

// Styles for Dropdown Content:
.wrap-content {
    //padding: 30px;
    // Set the width manually so that it does not depend
    // on changing content
    width: 100%;
    height: 100%;
}

.wrap-content__block {
}

.wrap-content__item {
    height: 100%;
    width: 100%;
}

</style>
